import React from "react";
import { Route, Routes, Navigate } from "react-router";
import { 
  DigitarEmpleadoMenuComida, 
  ReporteCafeteriaSemanal,
  RegistrarAlmuerzoSemanalRRHH,
  DigitarMenuComboEmpleado,
  DigitarListadoMenuEmpleados,
  SemanasAlmuerzo,
  RacionComida,
  DigitarListadoCombosComida,
  UsuariosBloqueadosCafeteria,
  AgregarUsuariosRestriccion
} from "../pages/Cafeteria";

import { RequiredPermission } from "../authentication/RequiredPermission";

export const RutasCafeteria = () => {

  return (
    <Routes>

      {/* <Route path="/registrarMenu" element={<DigitarEmpleadoMenuComida />} /> */}
      <Route path="/registrarMenu" element={<DigitarMenuComboEmpleado />} />

      <Route element={<RequiredPermission permission={['ROLE_ADMIN', 'ROLE_GENERAR_REPORTE_CAFETERIA']} />}>
        {/* <Route path="/reporte/historico" element={<ReporteHistorico />} />
        <Route path="/reporte/estadistica" element={<ReporteEstadistica />} /> */}
        <Route path="/reporte/semanal" element={<ReporteCafeteriaSemanal />} />
      </Route>

      <Route element={<RequiredPermission permission={['ROLE_ADMIN', 'ROLE_CAFETERIA_CREAR_SEMANA_ALMUERZO' ]} />}>
        <Route path="/semanasAlmuerzo" element={<SemanasAlmuerzo />} />
        {/* <Route path="/registro/menuSemanal" element={<RegistrarAlmuerzoSemanalRRHH />} /> */}
        <Route path="/registro/menuSemanal" element={<DigitarListadoCombosComida />} />
      </Route>
      
      <Route element={<RequiredPermission permission={['ROLE_DIGITAR_SUBSIDIO_COMIDA_CAFETERIA', 'ROLE_ADMIN']} />}>
        <Route index element={<RacionComida />} />
      </Route>

      <Route element={<RequiredPermission permission={['ROLE_DIGITAR_SUBSIDIO_COMIDA_CAFETERIA', 'ROLE_ADMIN']} />}>
        <Route path="/registrarMenu/empleados" element={<DigitarListadoMenuEmpleados />} />
      </Route>

      <Route element={<RequiredPermission permission={['ROLE_ADMIN', 'ROLE_CAFETERIA_RESTRICCION_USUARIOS']} />}>
        <Route path="/restriccion/agregar" element={<AgregarUsuariosRestriccion />} />
        <Route path="/restriccion" element={<UsuariosBloqueadosCafeteria />} />
      </Route>

      {/* <Route element={<RequiredPermission permission='ROLE_ADMIN' />}>
        <Route path="/reporte/historico" element={<ReporteHistorico />} />
        <Route path="/reporte/estadistica" element={<ReporteEstadistica />} />
      </Route> */}

      <Route path='/*' element={<Navigate to="/" replace />} />

    </Routes>
  );
};
